<div class="bg-m0 flex h-56 select-none flex-col items-center p-9">
  <div>
    <m-completed-ring></m-completed-ring>
  </div>

  <div
    data-cy="emailIsConfirmedDialogTitle"
    class="text-s2 mt-5 flex-grow text-2xl font-semibold"
    >Email is confirmed!</div
  >

  <div>
    <button
      class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
      (click)="onOk()"
      >Ok</button
    >
  </div>
</div>
